import { render, staticRenderFns } from "./CreditGainMenu.vue?vue&type=template&id=8dd87642&scoped=true&"
import script from "./CreditGainMenu.vue?vue&type=script&lang=js&"
export * from "./CreditGainMenu.vue?vue&type=script&lang=js&"
import style0 from "./CreditGainMenu.vue?vue&type=style&index=0&id=8dd87642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd87642",
  null
  
)

export default component.exports